// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a6d079b2","239":"e8e3f403","455":"f1b390ec"}[chunkId] + ".chunk.js";
};